import Vue from 'vue'
import Vuex from 'vuex'
import moduleUser from './moduleUser/moduleUser'
Vue.use(Vuex)



export default new Vuex.Store({
  state: {
    cart_refresh : false 
  },
  mutations: {
    cart_refresh_open(state) {
      state.cart_refresh = true;
    },
    cart_refresh_close(state) {
      state.cart_refresh = false ;
    }
  },
  actions: {

  },
  modules: {
    moduleUser : moduleUser,
  }
})
